<!--
  Main Platform Navigation UI - covers leftbar, topbar, burger menu

  Using css fixed position trick - we can "extract" some sections of the "topbar" to leftbar/burgermenu

  - mobile : the whole `<div class="menus">` IS the Burger Menu sidebar
  - desktop:  only `<evc-navigation-secondary>` is shown as leftbar
    - we do actualy have a leftbar component which is empty; only act as a spacer for the rest of the app

  all content outside of .menus will allways be present on the topbar !

  2 other css tricks (use webcomponent utils classes):
  - z-above: need to apply z-index to elements to be over the background pannel (use :before)
  - mobile-only/desktop-only: only shown on mobile/desktop layout (cutoff: 900px)
-->
@let identity = appIdentity();
@let primary = navigationPrimary();
@let secondary = navigationSecondary();
@let tertiary = navigationTertiary();
@let burgerIsOpen = isBurgerMenuOpen();
@let leftbarIsOpen = isLeftbarOpen();

<!-- TODO make it a component so style active state with anim morph X -->
<evc-button
  data-testid="burger"
  class="burger z-above mobile-only"
  icon="burger-menu"
  frame="none"
  (click)="toggleBurgerMenu()"
  [active]="burgerIsOpen" />

<evc-logo
  data-testid="logo"
  class="logo z-above"
  [title]="identity.title"
  [logo]="identity.logo"
  [onTitleClick]="identity.onTitleClick">
  <ng-content
    custom-logo
    select="[custom-logo]" />
</evc-logo>

<div
  class="menus"
  [attr.data-burger-open]="burgerIsOpen">
  <div class="menus__top-content mobile-only">
    <ng-content
      content-before
      select="[burger-top-content]" />
  </div>
  <!-- <pre class="_debug">{{tertiary|json}}</pre> -->
  <evc-navigation-primary
    class="navigation navigation--primary z-above"
    [items]="primary"
    [isIms]="isIms()"
    [host]="tertiary.host"
    [attr.data-empty]="primary.length <= 0" />

  <evc-navigation-secondary
    class="navigation navigation--secondary leftbar"
    [menus]="secondary"
    [attr.data-use-leftbar]="useLeftbar()"
    [attr.data-leftbar-open]="leftbarIsOpen"
    [attr.data-empty]="!secondary || secondary.length === 0"
    [collapsed]="!leftbarIsOpen"
    [host]="secondaryHost()">
    <div
      class="desktop-only"
      content-before>
      <ng-content select="[leftbar-top-content]" />
    </div>
    <div
      class="desktop-only navigation--secondary--after"
      content-after>
      <ng-content select="[leftbar-bottom-content]" />
      @if (useLeftbar()) {
        <evc-button
          data-testid="leftbar-toggle"
          class="leftbar__toggle"
          size="small"
          (click)="toggleLeftbar()"
          frame="ghost"
          [icon]="leftbarIsOpen ? icons.SIDEBAR_COLLAPSE : icons.SIDEBAR_EXPAND">
        </evc-button>
      }
    </div>
  </evc-navigation-secondary>

  <evc-navigation-tertiary
    class="navigation navigation--tertiary z-above"
    [isIms]="isIms()"
    [displayThemeSelector]="tertiary.displayThemeSelector"
    [settings]="tertiary.settings"
    [help]="tertiary.help"
    [langs]="tertiary.langs"
    [user]="tertiary.user"
    [mode]="tertiary.mode"
    [host]="tertiary.host"
    [login]="login()"
    [logout]="logout()"
    [changeOrganization]="changeOrganization()">
    <div
      extra-settings
      class="desktop-only">
      <ng-content select="[extra-settings]" />
    </div>
    <div
      content-after
      class="mobile-only">
      <ng-content select="[burger-bottom-content]" />
    </div>
  </evc-navigation-tertiary>
</div>
<div
  class="menus__burger-overlay mobile-only"
  (click)="toggleBurgerMenu(false)"></div>

@if (shouldDisplayApplicationsIcon()) {
  <evc-apps-menu
    class="z-above"
    [isIms]="isIms()" />
}

<div class="mobile-main-action mobile-only">
  <ng-content
    mobile-main-action
    select="[mobile-main-action]" />
</div>
